<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  danger: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <section
    class="rounded-xl border bg-gray-900"
    :class="danger ? 'border-danger-900/60' : 'border-gray-800'"
  >
    <header class="flex flex-col gap-3 border-b px-6 py-5 sm:flex-row sm:items-center" :class="danger ? 'border-danger-900/60' : 'border-gray-800'">
      <div class="flex flex-1 flex-col gap-1">
        <h3 class="text-base font-semibold leading-6" :class="danger ? 'text-danger-400' : 'text-text-primary'">
          {{ title }}
        </h3>
        <p v-if="description" class="max-w-2xl text-sm text-text-secondary">{{ description }}</p>
      </div>
      <slot name="actions" />
    </header>
    <slot />
  </section>
</template>
